import AddApplicableLaw from './AddApplicableLaw'

export default AddApplicableLaw
